"use client";
import { jsx as a } from "react/jsx-runtime";
import { Command as f, useCommandState as P, useCommandStore as V } from "../atoms/cmdk/index.js";
import { ikp as r } from "./factory.js";
import { dataAttr as I, maybeRender as E } from "../utils/misc.js";
import { forwardRef as L, useMemo as w, useEffect as A, useState as q, useCallback as N, useRef as H } from "react";
import { useSearch as m } from "./embedded-search/search-provider.js";
import { SearchProvider as ui } from "./embedded-search/search-provider.js";
import z from "./tagline-logo-icon.js";
import { CustomIcon as g } from "../atoms/icons/custom-icon.js";
import * as k from "@radix-ui/react-scroll-area";
import * as C from "@radix-ui/react-tabs";
import { useInkeepConfig as p } from "../providers/config-provider.js";
import { useSearchEvents as J } from "../providers/search-events-provider.js";
import { LinkWithQueryParams as M } from "../atoms/link.js";
import { SourceItemProvider as W, useSourceItem as _ } from "../providers/source-item-provider.js";
import { BuiltInIconRenderer as U } from "../atoms/icons/built-in-icon-renderer.js";
import { highlightEmphasis as X } from "../utils/highlight-emphasis.js";
import { useScrollingFades as Y } from "../hooks/use-scrolling-fades.js";
import { useColorModeValue as Z } from "@inkeep/cxkit-color-mode";
import ee from "../atoms/avatars/ai.js";
import { useModal as $ } from "./modal/modal-provider.js";
import { useComposedRefs as x } from "../utils/compose-refs.js";
import { composeEventHandlers as O } from "../utils/compose-event-handlers.js";
import { useShadow as te } from "../atoms/shadow/context.js";
import { Markdown as ie } from "../atoms/markdown/index.js";
import { useMediaQuery as F } from "../hooks/use-media-query.js";
import { useSearchFetch as re } from "./embedded-search/use-search-filter.js";
import { getUrlWithQuery as se } from "./embedded-search/url-query.js";
import { ASK_AI_TRIGGER_VALUE as T } from "../constants/search.js";
const ne = r("div", {
  _id: "aiSearchWrapper"
}), ht = (e) => {
  const {
    searchSettings: { view: t }
  } = p(), { isHidden: i, hasContent: s } = m(), n = F("(max-width: 768px)"), o = $();
  return /* @__PURE__ */ a(
    ne,
    {
      "data-hidden": I(i),
      "data-has-content": I(s),
      "data-in-modal": I(!!o),
      "data-mobile": I(n),
      "data-view": t,
      "data-dual-pane-search-expanded": I(s && t === "dual-pane" && !i),
      ...e
    }
  );
}, ae = r("div", {
  _id: "aiSearchRoot"
}), It = (e) => {
  const { isHidden: t } = m(), i = F("(max-width: 768px)");
  return /* @__PURE__ */ a(ae, { "data-hidden": I(t), "data-mobile": I(i), ...e });
}, oe = r(f.List, {
  _id: "aiSearchContent"
}), vt = L((e, t) => {
  const i = P((s) => s.value);
  return /* @__PURE__ */ a(
    oe,
    {
      "aria-activedescendant": `aiSearchResults__Item-${i}`,
      ...e,
      ref: t
    }
  );
}), _t = r("div", {
  _id: "aiSearchInputGroup"
}), St = r(g, {
  _id: "aiSearchInputIcon",
  iconKey: "search"
}), ce = r(f.Input, {
  _id: "aiSearchInput"
}), pt = L(({ onInput: e, ...t }, i) => {
  const { inputRef: s, shouldAutoFocusInput: n } = m(), o = P((u) => u.value), l = F("(max-width: 768px)"), { searchSettings: c } = p(), d = w(
    () => c.placeholder || (l ? "Search..." : "Search for anything..."),
    [c.placeholder, l]
  ), v = x(i, s), h = $();
  return A(() => {
    requestAnimationFrame(() => {
      n && s?.current && (s.current.focus(), s.current.selectionStart = s.current.value.length);
    });
  }, [n, s, h?.isOpen]), re(), /* @__PURE__ */ a(
    ce,
    {
      ref: v,
      placeholder: d,
      "aria-activedescendant": `aiSearchResults__Item-${o}`,
      ...t
    }
  );
}), le = r(U, {
  _id: "aiSearchLoading",
  iconSettings: {
    builtIn: "LuLoaderCircle"
  }
}), bt = (e) => {
  const { loading: t, resultsList: i } = m();
  return !t || i.length === 0 ? null : /* @__PURE__ */ a(le, { ...e });
}, de = r(f.Item, {
  _id: "aiAskAITrigger",
  value: T
}), Rt = (e) => {
  const { results: t, tab: i } = m(), s = V(), n = t[i]?.[0]?.id ?? "NONE";
  return /* @__PURE__ */ a(
    de,
    {
      ...e,
      id: `aiSearchResults__Item-${T}`,
      tabIndex: 0,
      onPointerLeave: () => s.setState("value", n, !0)
    }
  );
}, ue = r("img", {
  _id: "aiAskAITrigger__Icon"
}), Pt = (e) => {
  const { aiChatSettings: t } = p(), { aiAssistantAvatar: i } = t ?? {}, s = typeof i == "string" ? i : i?.light, n = (typeof i == "string" ? i : i?.dark) ?? s, o = Z(s, n), [l, c] = q(o);
  return A(() => {
    c(o);
  }, [o]), /* @__PURE__ */ a(ue, { asChild: !0, ...e, children: l ? (
    // biome-ignore lint/a11y/useAltText: <explanation>
    /* @__PURE__ */ a(
      "img",
      {
        src: l,
        alt: "AI Avatar",
        "data-type": "image",
        onError: O(() => {
          c(null);
        }),
        ...e
      }
    )
  ) : /* @__PURE__ */ a(ee, { "data-type": "icon", ...e }) });
}, gt = r("span", {
  _id: "aiAskAITrigger__Label"
}), wt = r(g, {
  _id: "aiAskAITrigger__Indicator",
  iconKey: "openLinkInSameTab"
}), me = r(C.Root, {
  _id: "aiSearchResults"
}), Tt = (e) => {
  const {
    searchSettings: { view: t }
  } = p(), { tab: i, setTab: s, hasContent: n, isHidden: o, disableTransition: l, results: c, defaultTab: d } = m(), v = V(), h = N(
    (u) => {
      l(), s(u);
      const S = c[u][0] ? c[u][0]?.id : void 0;
      v.setState("value", S, !0);
    },
    [c, l]
  );
  return A(() => {
    let u = i in c ? i : Object.keys(c)[0];
    if (!c[u]?.length) {
      const b = Object.keys(c).find((y) => c[y]?.length);
      b ? u = b : u = d;
    }
    if (!u) return;
    s(u);
    const S = c[u]?.[0];
    S && v.setState("value", S.id, !0);
  }, [c]), /* @__PURE__ */ a(
    me,
    {
      value: i,
      onValueChange: h,
      "data-has-content": I(n),
      "data-dual-pane-search-expanded": I(n && t === "dual-pane" && !o),
      ...e
    }
  );
}, he = r("div", {
  _id: "aiSearchResults__Loading"
}), ft = (e) => {
  const { loading: t, resultsList: i } = m();
  return !t || i.length > 0 ? null : /* @__PURE__ */ a(he, { ...e });
}, Ie = r(f.Empty, {
  _id: "aiSearchResults__Empty"
}), Et = (e) => {
  const t = P((l) => l.search), { loading: i, results: s, tab: n } = m(), o = s[n]?.length;
  return i || !t || o ? null : /* @__PURE__ */ a(Ie, { children: "No results found.", ...e });
}, ve = r(C.List, {
  _id: "aiSearchResults__TabList"
}), Lt = (e) => {
  const { children: t, ...i } = e, {
    searchSettings: { tabs: s }
  } = p(), { results: n, loading: o, resultsList: l } = m();
  if (o && l.length === 0) return null;
  const c = Object.keys(n);
  return !s.length || !c.length ? null : /* @__PURE__ */ a(ve, { tabIndex: -1, children: E(t, c), ...i });
}, _e = r(C.Trigger, {
  _id: "aiSearchResults__Tab"
}), At = L((e, t) => {
  const i = H(null), s = x(t, i), { tab: n, onClick: o, ...l } = e, { results: c, tab: d, inputRef: v } = m(), h = c[n].length, u = n === d, S = () => {
    v.current?.focus();
  }, b = te();
  return A(() => {
    u && b?.shadowHost?.shadowRoot?.activeElement?.hasAttribute("ikp-tab") && i.current?.focus();
  }, [u]), /* @__PURE__ */ a(
    _e,
    {
      ref: s,
      "ikp-tab": "",
      tabIndex: u ? 0 : -1,
      value: n,
      children: `${n} (${h})`,
      onClick: O(o, S),
      ...l
    }
  );
}), kt = r("div", {
  _id: "aiSearchResults__Content"
}), Se = r(k.Root, {
  _id: "aiSearchResults__ScrollArea"
}), yt = (e) => {
  const { loading: t, resultsList: i } = m();
  return t && i.length === 0 ? null : /* @__PURE__ */ a(Se, { tabIndex: -1, ...e });
}, pe = r(k.Viewport, {
  _id: "aiSearchResults__ScrollAreaViewport"
}), Ot = L(({ children: e, ...t }, i) => {
  const s = Y(), n = x(i, s), { tab: o } = m();
  return A(() => {
    o && s.current?.scrollTo({ top: 0, behavior: "auto" });
  }, [o]), /* @__PURE__ */ a(
    pe,
    {
      ref: n,
      tabIndex: -1,
      children: (
        /* added this to fix an overflow issue see https://github.com/radix-ui/primitives/issues/926 */
        /* @__PURE__ */ a("div", { tabIndex: -1, style: { display: "grid" }, children: e })
      ),
      ...t
    }
  );
}), Ct = r(
  k.ScrollAreaScrollbar,
  {
    _id: "aiSearchResults__ScrollAreaScrollbar"
  }
), xt = r(k.ScrollAreaThumb, {
  _id: "aiSearchResults__ScrollAreaThumb"
}), Bt = r(k.Corner, {
  _id: "aiSearchResults__ScrollAreaCorner"
}), be = r(C.Content, {
  _id: "aiSearchResults__List"
}), Nt = (e) => {
  const { children: t, ...i } = e, { results: s, tab: n } = m(), o = s[n] ?? [];
  return /* @__PURE__ */ a(
    be,
    {
      value: n,
      "data-has-results": I(o.length > 0),
      "aria-label": "Search results",
      children: E(t, o),
      tabIndex: -1,
      ...i
    }
  );
}, Re = r(f.Item, {
  _id: "aiSearchResults__Item",
  asChild: !0
}), Ht = L(({ item: e, onClick: t, onSelect: i, children: s, ...n }, o) => {
  const {
    searchSettings: { shouldOpenLinksInNewTab: l, view: c, searchQueryParamKey: d }
  } = p(), { logEvent: v } = J(), h = P((R) => R.search), { transitionsDisabled: u } = m(), S = P((R) => R.value), b = H(null), y = x(o, b), D = N((R) => {
    R.trigger === "keyboard" && b.current?.click();
  }, []), G = N(() => {
    v({
      eventName: "search_result_clicked",
      properties: {
        searchQuery: h,
        title: e.title,
        url: e.url
      }
    });
  }, [v, h, e.title, e.url]), B = w(
    () => e.shouldOpenInNewTab !== void 0 ? e.shouldOpenInNewTab : l,
    [e.shouldOpenInNewTab, l]
  ), K = S === e.id, Q = K || (S === "NONE" || S === T), j = w(() => ({
    href: d ? se(e.url, h, d) : e.url,
    isExternal: B,
    appendToUrl: e.appendToUrl,
    children: s,
    id: `aiSearchResults__Item-${e.id}`
  }), [e.url, B, e.appendToUrl, s, e.id, d, h]);
  return /* @__PURE__ */ a(W, { source: { ...e, isExternal: B }, children: /* @__PURE__ */ a(
    Re,
    {
      ref: y,
      value: e.id,
      "data-type": e.type,
      "data-breadcrumbs": !!e.breadcrumbs?.length,
      "data-disable-transitions": I(u),
      "data-view": c,
      onSelect: O(i, D),
      onClick: O(t, G),
      "data-selected": I(K),
      tabIndex: Q ? 0 : -1,
      ...n,
      children: /* @__PURE__ */ a(M, { ...j })
    }
  ) });
}), Pe = r("div", {
  _id: "aiSearchResults__ItemBreadcrumbs"
}), ge = (e) => {
  const { source: t } = _(), { tab: i } = m();
  if (!t.breadcrumbs?.length) return null;
  const { children: s, ...n } = e, l = t.tabs?.find((c) => typeof c != "string" && c[0] === i)?.[1]?.breadcrumbs ?? t.breadcrumbs ?? [];
  return /* @__PURE__ */ a(
    Pe,
    {
      "aria-hidden": "true",
      children: E(s, l),
      ...n
    }
  );
}, we = r(g, {
  _id: "aiSearchResults__ItemBreadcrumbIcon",
  iconKey: "breadcrumbSeparator"
}), Te = r(U, {
  _id: "aiSearchResults__ItemIcon"
}), Mt = (e) => {
  const { source: t } = _();
  return /* @__PURE__ */ a(Te, { iconSettings: t.icon, "data-type": t.type, ...e });
}, fe = r("span", {
  _id: "aiSearchResults__ItemTitle"
}), Ut = (e) => {
  const { source: t } = _();
  return /* @__PURE__ */ a(fe, { "data-type": t.type, children: t.title, ...e });
}, Ee = r("span", {
  _id: "aiSearchResults__ItemTag"
}), Ft = (e) => {
  const { source: t } = _();
  return /* @__PURE__ */ a(Ee, { "data-type": t.type, children: t.tag, ...e });
}, Le = r("span", {
  _id: "aiSearchResults__ItemDescription"
}), Dt = (e) => {
  const { source: t } = _(), { children: i, ...s } = e, n = w(() => t.description ? X(t.description) : [], [t.description]);
  return n.length ? /* @__PURE__ */ a(
    Le,
    {
      "data-type": t.type,
      "aria-hidden": "true",
      children: E(i, n),
      ...s
    }
  ) : null;
}, Ae = r("span", {
  _id: "aiSearchResults__ItemDescriptionPart"
}), Kt = (e) => {
  const { part: t, ...i } = e, { source: s } = _();
  return typeof t == "string" ? t : /* @__PURE__ */ a(
    Ae,
    {
      "data-type": s.type,
      children: t.content,
      "data-highlighted": I(t.highlighted),
      ...i
    }
  );
}, ke = r(g, {
  _id: "aiSearchResults__ItemIndicator"
}), Vt = (e) => {
  const { source: t } = _(), {
    searchSettings: { view: i }
  } = p();
  return /* @__PURE__ */ a(
    ke,
    {
      iconKey: t.isExternal ? "openLinkInNewTab" : "openLinkInSameTab",
      "data-view": i,
      ...e
    }
  );
}, ye = r("div", {
  _id: "aiSearchResults__ItemPreview",
  "aria-hidden": !0
}), Wt = (e) => {
  const {
    searchSettings: { view: t, shouldOpenLinksInNewTab: i }
  } = p(), { results: s, tab: n } = m(), o = P((h) => h.value), l = s[n] ?? [], c = H(null), d = w(() => {
    if (o === T) return c.current;
    const h = l.find((u) => u.id === o);
    return c.current = h ?? null, h;
  }, [o]);
  if (t !== "dual-pane" || o === T || !d) return null;
  const v = d.shouldOpenInNewTab !== void 0 ? d.shouldOpenInNewTab : i;
  return /* @__PURE__ */ a(W, { source: { ...d, isExternal: v }, children: /* @__PURE__ */ a(ye, { ...e }) });
}, $t = r("div", {
  _id: "aiSearchResults__ItemPreview__Header"
}), Oe = r(M, {
  _id: "aiSearchResults__ItemPreview__Heading"
}), Gt = (e) => {
  const { source: t } = _();
  return /* @__PURE__ */ a(
    Oe,
    {
      href: t.url,
      isExternal: t.isExternal,
      appendToUrl: t.appendToUrl,
      "data-type": t.type,
      ...e
    }
  );
}, Ce = r("span", {
  _id: "aiSearchResults__ItemPreview__Title"
}), Qt = (e) => {
  const { source: t } = _();
  return /* @__PURE__ */ a(Ce, { children: t.title, ...e });
}, xe = r(g, {
  _id: "aiSearchResults__ItemPreview__Title__LinkIcon",
  iconKey: "openLinkInNewTab"
}), jt = (e) => {
  const { source: t } = _();
  return /* @__PURE__ */ a(
    xe,
    {
      iconKey: t.isExternal ? "openLinkInNewTab" : "openLinkInSameTab",
      ...e
    }
  );
}, qt = r(
  ge,
  {
    _id: "aiSearchResults__ItemPreview__Breadcrumbs"
  }
), zt = r(
  we,
  {
    _id: "aiSearchResults__ItemPreview__BreadcrumbIcon"
  }
), Be = r(ie, {
  _id: "aiSearchResults__ItemPreview__Body"
}), Jt = (e) => {
  const { source: t } = _(), { resultsList: i } = m(), s = i.find((o) => o.id === t.id), {
    searchSettings: { shouldOpenLinksInNewTab: n }
  } = p();
  return s ? /* @__PURE__ */ a(
    Be,
    {
      shouldOpenLinksInNewTab: n,
      children: s.preview,
      ...e
    }
  ) : null;
}, Ne = r("div", {
  _id: "aiSearchResults__ItemPreview__Outline"
}), Xt = (e) => {
  const { source: t } = _(), { resultsList: i } = m();
  return i.find((o) => o.id === t.id)?.rootRecord.topLevelHeadings?.length ? /* @__PURE__ */ a(Ne, { ...e }) : null;
}, Yt = r("span", {
  _id: "aiSearchResults__ItemPreview__Outline__Title",
  children: "On this page"
}), He = r("ul", {
  _id: "aiSearchResults__ItemPreview__Outline__List"
}), Zt = (e) => {
  const { source: t } = _(), { resultsList: i } = m(), s = i.find((d) => d.id === t.id), n = s?.rootRecord.topLevelHeadings;
  if (!n?.length) return null;
  const o = n.map((d) => {
    const v = d?.anchor && d?.anchor === s?.content?.anchor, h = d?.anchor === s?.pathHeadings?.[0]?.anchor;
    return {
      ...d,
      isMatch: v || h
    };
  }), { children: l, ...c } = e;
  return /* @__PURE__ */ a(He, { children: E(l, o), ...c });
}, Me = r(M, {
  _id: "aiSearchResults__ItemPreview__Outline__Item"
}), ei = (e) => {
  const {
    searchSettings: { shouldOpenLinksInNewTab: t }
  } = p();
  return /* @__PURE__ */ a(Me, { isExternal: t, ...e });
}, ti = r(g, {
  _id: "aiSearchResults__ItemPreview__Outline__ItemIcon",
  iconKey: "newLine"
}), Ue = r("span", {
  _id: "aiSearchResults__ItemPreview__Outline__ItemText"
}), ii = (e) => /* @__PURE__ */ a(Ue, { ...e }), ri = r(
  U,
  {
    _id: "aiSearchResults__ItemPreview__Outline__ItemLinkIcon",
    iconSettings: {
      builtIn: "LuLink"
    }
  }
), Fe = r("div", {
  _id: "aiSearchFooter"
}), si = (e) => {
  const { hasContent: t } = m();
  return /* @__PURE__ */ a(Fe, { "data-has-results": I(t), ...e });
}, ni = r("div", {
  _id: "aiSearchTagline__Container"
}), ai = r("span", {
  _id: "aiSearchTagline__Text",
  children: "Powered by"
}), oi = r(z, {
  _id: "aiSearchTagline__Logo"
}), ci = r("a", {
  _id: "aiSearchTagline__BrandName",
  children: "inkeep",
  href: "https://www.inkeep.com/",
  target: "_blank",
  rel: "noopener noreferrer"
});
export {
  Rt as AskAITrigger,
  Pt as AskAITriggerIcon,
  wt as AskAITriggerIndicator,
  gt as AskAITriggerLabel,
  vt as Content,
  St as EmbeddedSearchInputIcon,
  Rt as EmbeddedSearchPrimitiveAskAITrigger,
  Pt as EmbeddedSearchPrimitiveAskAITriggerIcon,
  wt as EmbeddedSearchPrimitiveAskAITriggerIndicator,
  gt as EmbeddedSearchPrimitiveAskAITriggerLabel,
  vt as EmbeddedSearchPrimitiveContent,
  si as EmbeddedSearchPrimitiveFooter,
  pt as EmbeddedSearchPrimitiveInput,
  _t as EmbeddedSearchPrimitiveInputGroup,
  bt as EmbeddedSearchPrimitiveLoading,
  Tt as EmbeddedSearchPrimitiveResults,
  kt as EmbeddedSearchPrimitiveResultsContent,
  Et as EmbeddedSearchPrimitiveResultsEmpty,
  Ht as EmbeddedSearchPrimitiveResultsItem,
  ge as EmbeddedSearchPrimitiveResultsItemBreadcrumbs,
  Dt as EmbeddedSearchPrimitiveResultsItemDescription,
  Kt as EmbeddedSearchPrimitiveResultsItemDescriptionPart,
  Mt as EmbeddedSearchPrimitiveResultsItemIcon,
  Vt as EmbeddedSearchPrimitiveResultsItemIndicator,
  Wt as EmbeddedSearchPrimitiveResultsItemPreview,
  Jt as EmbeddedSearchPrimitiveResultsItemPreviewBody,
  zt as EmbeddedSearchPrimitiveResultsItemPreviewBreadcrumbIcon,
  Gt as EmbeddedSearchPrimitiveResultsItemPreviewHeading,
  Xt as EmbeddedSearchPrimitiveResultsItemPreviewOutline,
  ei as EmbeddedSearchPrimitiveResultsItemPreviewOutlineItem,
  ti as EmbeddedSearchPrimitiveResultsItemPreviewOutlineItemIcon,
  ri as EmbeddedSearchPrimitiveResultsItemPreviewOutlineItemLinkIcon,
  ii as EmbeddedSearchPrimitiveResultsItemPreviewOutlineItemText,
  Zt as EmbeddedSearchPrimitiveResultsItemPreviewOutlineList,
  Yt as EmbeddedSearchPrimitiveResultsItemPreviewOutlineTitle,
  Qt as EmbeddedSearchPrimitiveResultsItemPreviewTitle,
  jt as EmbeddedSearchPrimitiveResultsItemPreviewTitleLinkIcon,
  Ft as EmbeddedSearchPrimitiveResultsItemTag,
  Ut as EmbeddedSearchPrimitiveResultsItemTitle,
  Nt as EmbeddedSearchPrimitiveResultsList,
  ft as EmbeddedSearchPrimitiveResultsLoading,
  yt as EmbeddedSearchPrimitiveResultsScrollArea,
  Ot as EmbeddedSearchPrimitiveResultsScrollAreaViewport,
  At as EmbeddedSearchPrimitiveResultsTab,
  Lt as EmbeddedSearchPrimitiveResultsTabList,
  It as EmbeddedSearchPrimitiveRoot,
  ht as EmbeddedSearchPrimitiveWrapper,
  si as Footer,
  pt as Input,
  _t as InputGroup,
  St as InputIcon,
  bt as Loading,
  oe as PrimitiveContent,
  ui as Provider,
  Tt as Results,
  kt as ResultsContent,
  Et as ResultsEmpty,
  Ht as ResultsItem,
  we as ResultsItemBreadcrumbIcon,
  ge as ResultsItemBreadcrumbs,
  Dt as ResultsItemDescription,
  Kt as ResultsItemDescriptionPart,
  Mt as ResultsItemIcon,
  Vt as ResultsItemIndicator,
  Wt as ResultsItemPreview,
  Jt as ResultsItemPreviewBody,
  zt as ResultsItemPreviewBreadcrumbIcon,
  qt as ResultsItemPreviewBreadcrumbs,
  $t as ResultsItemPreviewHeader,
  Gt as ResultsItemPreviewHeading,
  Xt as ResultsItemPreviewOutline,
  ei as ResultsItemPreviewOutlineItem,
  ti as ResultsItemPreviewOutlineItemIcon,
  ri as ResultsItemPreviewOutlineItemLinkIcon,
  ii as ResultsItemPreviewOutlineItemText,
  Zt as ResultsItemPreviewOutlineList,
  Yt as ResultsItemPreviewOutlineTitle,
  Qt as ResultsItemPreviewTitle,
  jt as ResultsItemPreviewTitleLinkIcon,
  Ft as ResultsItemTag,
  Ut as ResultsItemTitle,
  Nt as ResultsList,
  ft as ResultsLoading,
  yt as ResultsScrollArea,
  Bt as ResultsScrollAreaCorner,
  Ct as ResultsScrollAreaScrollbar,
  xt as ResultsScrollAreaThumb,
  Ot as ResultsScrollAreaViewport,
  At as ResultsTab,
  Lt as ResultsTabList,
  It as Root,
  ci as TaglineBrandName,
  ni as TaglineContainer,
  oi as TaglineLogo,
  ai as TaglineText,
  ht as Wrapper
};
